module.exports = __webpack_public_path__ + "static/media/RMG_Logo_Horizontal_White.7255c81b.png";